import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { t } from "i18next";

function TaxModal({ isOpen, toggle, taxRate, onTaxRateChange }) {
  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      zIndex={9999}
    >
      <ModalHeader>
        {t('sales.editTax')}
      </ModalHeader>

      <ModalBody>
        <div>
          <Label>{t('sales.taxPercent')}: </Label>
          <Input
            type="number"
            value={taxRate}
            onChange={e => onTaxRateChange(parseFloat(e.target.value))}
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <DefaultButton size="sm" color="secondary" onClick={toggle}>
          {t('common.cancel')}
        </DefaultButton>
        <DefaultButton size="sm" color="primary" onClick={() => {
          toggle();
        }}>{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default TaxModal;